import React, { useEffect } from "react";
import { Route, useHistory, useLocation } from 'react-router-dom';
import { connect } from "react-redux";
import { debug } from "../utils";
import * as authService from "./authService";
import { createAction } from "@reduxjs/toolkit";
import { ACTION_REFERER_PAGE_ADDED } from "./AuthReducer";

/**
 * The wrapper of the react-router-dom Route component.
 * Checks if the user is authorized and then renders a components.
 */
function ProtectedRoute({ component: Component, dispatch, access_token, userCapability, referer, ...data }) {
    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        if (location.pathname.startsWith("/login")) {
            debug("-- Skip token validation location=", location.pathname)
            return;
        }
        debug("--Start Token validation location=", location.pathname)
        authService.loadTokenFromLocalStorage()
            .catch(() => {
                dispatch(createAction(ACTION_REFERER_PAGE_ADDED)({ referer: location.pathname }))
                history.push("/login")
            })
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [location.pathname])

    if (!access_token) {
        return null;
    }

    return (
        <Route
            {...data}
            render={props => <Component {...props} />}
        />
    );
}

function mapStateToProps(state) {
    debug("ProtectedRoute mapStateToProps", state);
    return {
        access_token: state.auth.access_token,
        userCapability: state.auth.userCapability,
        referer: state.auth.referer
    };
}

export default connect(mapStateToProps)(ProtectedRoute);
